module.exports = __webpack_public_path__ + "fonts/61860563-e9eb-40bd-844e-48e96af9d063.8c22f00.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/AvenirNext/61860563-e9eb-40bd-844e-48e96af9d063.ttf
// module id = 176
// module chunks = 245 246